<template>
  <el-autocomplete v-model="values"
                   :disabled="disabled"
                   :fetch-suggestions="search"
                   clearable
                   @blur="blur"
                   @clear="clearItem"
                   @select="selectItem"
                   :value-key="itemName"
                   :placeholder="placeholder"/>
</template>

<script>

export default {
  name: 'CollaboratorUserNameAutoComplete',
  props: {
    value: { type: String, default: '' },
    placeholder: { type: String, default: '请输入' },
    disabled: { type: Boolean, default: false },
    aliasExist: { type: Boolean, default: false},
    searchList: { type: Array, default: () => [] }
  },
  data() {
    return {
      values: '',
      itemName: 'userName'
    };
  },
  created() {
    this.values = this.value;
  },
  watch: {
    value() {
      this.values = this.value;
    }
  },
  methods: {
    async search(qs, cb) {
      const results = qs ? this.searchList.filter(item => item.userName.indexOf(qs) !== -1) : this.searchList;
      cb(results);
    },
    blur() {
      this.values = this.value;
    },
    clearItem() {
      this.$emit('clear');
    },
    async selectItem(item) {
      if (item !== null) {
        this.$emit('update:value', item[this.itemName]);
        this.$emit('setValue', {
          ...item,
          index: this.index
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>

</style>
